import { WHY_US } from "@/lib/site";
import { Reveal } from "./Reveal";

export const WhyUs = () => {
  return (
    <section id="why-us" data-testid="why-us" className="py-24 lg:py-32 bg-surface">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand mb-4">01 — Why Choose Us</p>
          <h2 className="font-display font-extrabold text-navy tracking-tight text-4xl md:text-5xl max-w-2xl leading-[1.05]">
            A funding partner built around your business.
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {WHY_US.map((item, i) => (
            <Reveal key={item.title} delay={(i % 3) * 0.08}>
              <div
                data-testid={`why-card-${i}`}
                className="group h-full bg-white rounded-2xl p-8 border border-black/5 hover:-translate-y-1 hover:shadow-[0_24px_60px_-24px_rgba(15,27,61,0.25)] transition-[transform,box-shadow] duration-300"
              >
                <span className="grid place-items-center w-12 h-12 rounded-xl bg-navy text-white group-hover:bg-brand transition-colors">
                  <item.icon className="w-5 h-5" />
                </span>
                <h3 className="mt-6 font-display font-bold text-xl text-navy">{item.title}</h3>
                <p className="mt-2 text-sm text-ink/55 leading-relaxed">{item.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
